<!-- Overlay para móvil -->
<div *ngIf="isMobile && sidebarOpen" class="fixed inset-0 z-40 bg-black bg-opacity-50 lg:hidden"
  (click)="closeSidebar()">
</div>

<!-- Sidebar -->
<aside [ngClass]="{
    'translate-x-0': (isMobile && sidebarOpen) || (!isMobile),
    '-translate-x-full': isMobile && !sidebarOpen,
    'w-72': sidebarState === 'desktop-expanded' || sidebarState === 'mobile-open',
    'w-16': sidebarState === 'desktop-collapsed'
  }"
  class="fixed left-0 top-0 z-50 flex h-screen flex-col overflow-hidden bg-gradient-to-b from-gray-900 to-gray-800 shadow-2xl transition-all duration-300 ease-in-out lg:relative lg:translate-x-0">
  <!-- SIDEBAR HEADER -->
  <div class="border-b border-gray-700 px-4 py-4">

    <!-- Modo expandido -->
    <div *ngIf="sidebarState !== 'desktop-collapsed'">
      <!-- Botones de control en la parte superior -->
      <div class="flex items-center justify-end mb-4">
        <!-- Botón de colapsar/expandir para desktop -->
        <button (click)="toggleSidebar()"
          class="hidden rounded-lg p-2 text-gray-400 transition-colors hover:bg-gray-700 hover:text-white lg:flex"
          [attr.aria-label]="sidebarCollapsed ? 'Expandir sidebar' : 'Contraer sidebar'">
          <svg class="h-5 w-5 transition-transform duration-200" [ngClass]="{'rotate-180': sidebarCollapsed}"
            fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
          </svg>
        </button>

        <!-- Botón cerrar para móvil -->
        <button (click)="closeSidebar()"
          class="rounded-lg p-2 text-gray-400 transition-colors hover:bg-gray-700 hover:text-white lg:hidden"
          aria-label="Cerrar menú">
          <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>

      <!-- Logo y título centrados -->
      <div class="flex flex-col items-center text-center space-y-4">
        <div class="flex items-center justify-center">
          <img src="../../../assets/img/logo.png" alt="Logo" class="h-12 w-auto max-w-[200px] object-contain" />
        </div>
        <div class="transition-opacity duration-200">
          <p class="text-sm text-gray-400">Panel de Control</p>
        </div>
      </div>
    </div>

    <!-- Modo colapsado -->
    <div *ngIf="sidebarState === 'desktop-collapsed'" class="flex flex-col items-center space-y-3">
      <!-- Botón de expandir encima del logo -->
      <button (click)="toggleSidebar()"
        class="rounded-lg p-2 text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
        [attr.aria-label]="'Expandir sidebar'">
        <svg class="h-5 w-5 transition-transform duration-200 rotate-180" fill="none" stroke="currentColor"
          viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
        </svg>
      </button>

      <!-- Logo centrado -->
      <div class="relative group">
        <div class="flex items-center justify-center p-2">
          <img src="../../../assets/img/logo.png" alt="Logo" class="h-8 w-auto max-w-[48px] object-contain" />
        </div>
        <!-- Tooltip para modo colapsado -->
        <div class="tooltip">
          <div class="bg-gray-800 text-white text-xs rounded py-1 px-2 whitespace-nowrap">
            Finance System
          </div>
        </div>
      </div>
    </div>

  </div>
  <!-- SIDEBAR HEADER -->

  <!-- Navigation Menu -->
  <div class="flex-1 overflow-y-auto py-4">
    <nav class="space-y-1 px-3">

      <!-- Dashboard -->
      <div class="group">
        <a routerLink="/"
          class="flex items-center rounded-xl px-3 py-2.5 text-sm font-medium text-gray-300 transition-all duration-200 hover:bg-gray-700 hover:text-white group-hover:translate-x-1"
          routerLinkActive="bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-lg">
          <svg class="mr-3 h-5 w-5 flex-shrink-0" [ngClass]="{'mr-0': sidebarState === 'desktop-collapsed'}" fill="none"
            stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6" />
          </svg>
          <span *ngIf="sidebarState !== 'desktop-collapsed'" class="transition-opacity duration-200">Dashboard</span>
        </a>
      </div>

      <!-- Proyectos -->
      <div class="group" *ngIf="canViewProjects">
        <button (click)="toggleSubMenu('projects')"
          class="flex w-full items-center justify-between rounded-xl px-3 py-2.5 text-left text-sm font-medium text-gray-300 transition-all duration-200 hover:bg-gray-700 hover:text-white group-hover:translate-x-1"
          [ngClass]="{'bg-gray-700 text-white': subMenuOpen.projects}">
          <div class="flex items-center">
            <svg class="mr-3 h-5 w-5 flex-shrink-0" [ngClass]="{'mr-0': sidebarState === 'desktop-collapsed'}"
              fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
            <span *ngIf="sidebarState !== 'desktop-collapsed'" class="transition-opacity duration-200">Proyectos</span>
          </div>
          <svg *ngIf="sidebarState !== 'desktop-collapsed'" class="h-4 w-4 transition-transform duration-200"
            [ngClass]="{'rotate-180': subMenuOpen.projects}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        <div *ngIf="subMenuOpen.projects && sidebarState !== 'desktop-collapsed'"
          class="mt-1 space-y-1 border-l-2 border-gray-600 ml-6 pl-4 animate-slideDown">
          <a routerLink="/projects"
            class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
            routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400">
            Lista de Proyectos
          </a>
          <a *ngIf="hasPermission('PROJECTS_CREATE')" routerLink="/projects/new-project"
            class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
            routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400">
            Nuevo Proyecto
          </a>
        </div>
      </div>

      <!-- Personas -->
      <div class="group" *ngIf="canViewSuppliers || canViewCompanies || canViewParticipants">
        <button (click)="toggleSubMenu('thirdParties')"
          class="flex w-full items-center justify-between rounded-xl px-3 py-2.5 text-left text-sm font-medium text-gray-300 transition-all duration-200 hover:bg-gray-700 hover:text-white group-hover:translate-x-1"
          [ngClass]="{'bg-gray-700 text-white': subMenuOpen.thirdParties}">
          <div class="flex items-center">
            <svg class="mr-3 h-5 w-5 flex-shrink-0" [ngClass]="{'mr-0': sidebarState === 'desktop-collapsed'}"
              fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
            </svg>
            <span *ngIf="sidebarState !== 'desktop-collapsed'" class="transition-opacity duration-200">Personas</span>
          </div>
          <svg *ngIf="sidebarState !== 'desktop-collapsed'" class="h-4 w-4 transition-transform duration-200"
            [ngClass]="{'rotate-180': subMenuOpen.thirdParties}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        <div *ngIf="subMenuOpen.thirdParties && sidebarState !== 'desktop-collapsed'"
          class="mt-1 space-y-1 border-l-2 border-gray-600 ml-6 pl-4 animate-slideDown">
          <a *ngIf="canViewSuppliers" routerLink="/third-parties"
            class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
            routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400"
            title="Gestiona proveedores para generar comprobantes de egreso y pagos">
            <div>Lista de Proveedores</div>
            <div class="text-xs text-gray-500 mt-0.5">Crear y gestionar proveedores para egresos</div>
          </a>
          <a *ngIf="canViewCompanies" routerLink="/companies"
            class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
            routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400"
            title="Administra empresas para procesos de inscripción y facturación">
            <div>Lista de Empresas</div>
            <div class="text-xs text-gray-500 mt-0.5">Gestionar empresas para inscripciones</div>
          </a>
          <a *ngIf="canViewParticipants" routerLink="/participants"
            class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
            routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400"
            title="Administra estudiantes para inscripciones y seguimiento académico">
            <div>Lista de Estudiantes</div>
            <div class="text-xs text-gray-500 mt-0.5">Gestionar estudiantes e inscripciones</div>
          </a>
        </div>
      </div>

      <!-- Inscripciones (Submenú) -->
      <div class="group" *ngIf="canViewEnrollments">
        <button (click)="toggleSubMenu('enrollments')"
          class="flex w-full items-center justify-between rounded-xl px-3 py-2.5 text-left text-sm font-medium text-gray-300 transition-all duration-200 hover:bg-gray-700 hover:text-white group-hover:translate-x-1"
          [ngClass]="{'bg-gray-700 text-white': subMenuOpen.enrollments}">
          <div class="flex items-center">
            <svg class="mr-3 h-5 w-5 flex-shrink-0" [ngClass]="{'mr-0': sidebarState === 'desktop-collapsed'}"
              fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
            <span *ngIf="sidebarState !== 'desktop-collapsed'"
              class="transition-opacity duration-200">Inscripciones</span>
          </div>
          <svg *ngIf="sidebarState !== 'desktop-collapsed'" class="h-4 w-4 transition-transform duration-200"
            [ngClass]="{'rotate-180': subMenuOpen.enrollments}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        <div *ngIf="subMenuOpen.enrollments && sidebarState !== 'desktop-collapsed'"
          class="mt-1 space-y-1 border-l-2 border-gray-600 ml-6 pl-4 animate-slideDown">
          <a routerLink="/enrollments/individual"
            class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
            routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400">
            Individuales
          </a>
          <a routerLink="/enrollments/corporate"
            class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
            routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400">
            Empresariales
          </a>
          <!-- Cesiones de Cupo -->
          <a *ngIf="canViewEnrollmentTransfers" routerLink="/enrollment-transfers"
            class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
            routerLinkActive="bg-gradient-to-r from-purple-600/20 to-purple-500/20 text-purple-400">
            <span class="flex items-center">
              <svg class="mr-2 h-4 w-4 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
              </svg>
              Cesiones de Cupo
            </span>
          </a>
        </div>
      </div>

      <!-- Retiros y Aplazamientos -->
      <div class="group" *ngIf="canViewPortfolioManagement || canViewCorporatePortfolioManagement">
        <button (click)="toggleSubMenu('withdrawals')"
          class="flex w-full items-center justify-between rounded-xl px-3 py-2.5 text-left text-sm font-medium text-gray-300 transition-all duration-200 hover:bg-gray-700 hover:text-white group-hover:translate-x-1"
          [ngClass]="{'bg-gray-700 text-white': subMenuOpen.withdrawals}">
          <div class="flex items-center">
            <svg class="mr-3 h-5 w-5 flex-shrink-0" [ngClass]="{'mr-0': sidebarState === 'desktop-collapsed'}"
              fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
            </svg>
            <span *ngIf="sidebarState !== 'desktop-collapsed'" class="transition-opacity duration-200">Retiros y
              Aplazamientos</span>
          </div>
          <svg *ngIf="sidebarState !== 'desktop-collapsed'" class="h-4 w-4 transition-transform duration-200"
            [ngClass]="{'rotate-180': subMenuOpen.withdrawals}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        <div *ngIf="subMenuOpen.withdrawals && sidebarState !== 'desktop-collapsed'"
          class="mt-1 space-y-1 border-l-2 border-gray-600 ml-6 pl-4 animate-slideDown">

          <!-- Listados -->
          <div>
            <span class="block px-3 py-1 text-xs font-semibold text-gray-500 uppercase tracking-wider">Listados</span>

            <a routerLink="/enrollments/portfolio-movements/individual"
              class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
              routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400">
              <span class="flex items-center">
                <svg class="mr-2 h-4 w-4 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
                Movimientos Individuales
              </span>
            </a>

            <a routerLink="/enrollments/portfolio-movements/corporate"
              class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
              routerLinkActive="bg-gradient-to-r from-amber-600/20 to-amber-500/20 text-amber-400">
              <span class="flex items-center">
                <svg class="mr-2 h-4 w-4 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2" />
                </svg>
                Movimientos Corporativos
              </span>
            </a>
          </div>

          <!-- Gestión de Cartera -->
          <div *ngIf="canViewPortfolioManagement" class="mt-2 pt-2 border-t border-gray-700">
            <span class="block px-3 py-1 text-xs font-semibold text-gray-500 uppercase tracking-wider">Individual</span>

            <a *ngIf="canWithdrawEnrollments" routerLink="/enrollments/withdrawal-wizard"
              class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
              routerLinkActive="bg-gradient-to-r from-red-600/20 to-red-500/20 text-red-400">
              <span class="flex items-center">
                <svg class="mr-2 h-4 w-4 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M13 7a4 4 0 11-8 0 4 4 0 018 0zM9 14a6 6 0 00-6 6v1h12v-1a6 6 0 00-6-6zM21 12h-6" />
                </svg>
                Nuevo Retiro
              </span>
            </a>

            <a *ngIf="canReverseWithdrawals" routerLink="/enrollments/reversal-wizard"
              class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
              routerLinkActive="bg-gradient-to-r from-green-600/20 to-green-500/20 text-green-400">
              <span class="flex items-center">
                <svg class="mr-2 h-4 w-4 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" />
                </svg>
                Nueva Reversión
              </span>
            </a>

            <a *ngIf="canDeferEnrollments" routerLink="/enrollments/deferral-wizard"
              class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
              routerLinkActive="bg-gradient-to-r from-yellow-600/20 to-yellow-500/20 text-yellow-400">
              <span class="flex items-center">
                <svg class="mr-2 h-4 w-4 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Nuevo Aplazamiento
              </span>
            </a>
          </div>

          <!-- Gestión de Cartera Corporativa -->
          <div *ngIf="canViewCorporatePortfolioManagement" class="mt-2 pt-2 border-t border-gray-700">
            <span
              class="block px-3 py-1 text-xs font-semibold text-gray-500 uppercase tracking-wider">Corporativo</span>

            <a *ngIf="canWithdrawCorporateEnrollments" routerLink="/enrollments/corporate-withdrawal-wizard"
              class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
              routerLinkActive="bg-gradient-to-r from-red-600/20 to-red-500/20 text-red-400">
              <span class="flex items-center">
                <svg class="mr-2 h-4 w-4 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                </svg>
                Retiro Corporativo
              </span>
            </a>

            <a *ngIf="canReverseCorporateWithdrawals" routerLink="/enrollments/corporate-reversal-wizard"
              class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
              routerLinkActive="bg-gradient-to-r from-green-600/20 to-green-500/20 text-green-400">
              <span class="flex items-center">
                <svg class="mr-2 h-4 w-4 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6" />
                </svg>
                Reversión Corporativa
              </span>
            </a>

            <a *ngIf="canDeferCorporateEnrollments" routerLink="/enrollments/corporate-deferral-wizard"
              class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
              routerLinkActive="bg-gradient-to-r from-yellow-600/20 to-yellow-500/20 text-yellow-400">
              <span class="flex items-center">
                <svg class="mr-2 h-4 w-4 text-yellow-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                Aplazamiento Corporativo
              </span>
            </a>
          </div>
        </div>
      </div>

      <!-- Separador -->
      <div *ngIf="sidebarState !== 'desktop-collapsed'" class="my-4 border-t border-gray-600"></div>

      <!-- Ingresos -->
      <div class="group" *ngIf="canViewIncome">
        <button (click)="toggleSubMenu('incomes')"
          class="flex w-full items-center justify-between rounded-xl px-3 py-2.5 text-left text-sm font-medium text-gray-300 transition-all duration-200 hover:bg-gray-700 hover:text-white group-hover:translate-x-1"
          [ngClass]="{'bg-gray-700 text-white': subMenuOpen.incomes}">
          <div class="flex items-center">
            <svg class="mr-3 h-5 w-5 flex-shrink-0" [ngClass]="{'mr-0': sidebarState === 'desktop-collapsed'}"
              fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <span *ngIf="sidebarState !== 'desktop-collapsed'" class="transition-opacity duration-200">Ingresos</span>
          </div>
          <svg *ngIf="sidebarState !== 'desktop-collapsed'" class="h-4 w-4 transition-transform duration-200"
            [ngClass]="{'rotate-180': subMenuOpen.incomes}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        <div *ngIf="subMenuOpen.incomes && sidebarState !== 'desktop-collapsed'"
          class="mt-1 space-y-1 border-l-2 border-gray-600 ml-6 pl-4 animate-slideDown">
          <a routerLink="/income-receipts/individual"
            class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
            routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400">
            <span class="flex items-center">
              <svg class="mr-2 h-4 w-4 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              Comprobantes Individuales
            </span>
          </a>
          <a routerLink="/income-receipts/business"
            class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
            routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400">
            <span class="flex items-center">
              <svg class="mr-2 h-4 w-4 text-purple-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
              </svg>
              Comprobantes Empresariales
            </span>
          </a>
          <a routerLink="/income-receipts/pending-approvals"
            class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
            routerLinkActive="bg-gradient-to-r from-amber-600/20 to-amber-500/20 text-amber-400">
            <span class="flex items-center">
              <svg class="mr-2 h-4 w-4 text-amber-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Aprobaciones Pendientes
            </span>
          </a>
        </div>
      </div>

      <!-- Gastos -->
      <div class="group" *ngIf="canViewWorkOrders || canViewExpense">
        <button (click)="toggleSubMenu('expenses')"
          class="flex w-full items-center justify-between rounded-xl px-3 py-2.5 text-left text-sm font-medium text-gray-300 transition-all duration-200 hover:bg-gray-700 hover:text-white group-hover:translate-x-1"
          [ngClass]="{'bg-gray-700 text-white': subMenuOpen.expenses}">
          <div class="flex items-center">
            <svg class="mr-3 h-5 w-5 flex-shrink-0" [ngClass]="{'mr-0': sidebarState === 'desktop-collapsed'}"
              fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M17 9V7a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2m2 4h10a2 2 0 002-2v-6a2 2 0 00-2-2H9a2 2 0 00-2 2v6a2 2 0 002 2zm7-5a2 2 0 11-4 0 2 2 0 014 0z" />
            </svg>
            <span *ngIf="sidebarState !== 'desktop-collapsed'" class="transition-opacity duration-200">Gastos</span>
          </div>
          <svg *ngIf="sidebarState !== 'desktop-collapsed'" class="h-4 w-4 transition-transform duration-200"
            [ngClass]="{'rotate-180': subMenuOpen.expenses}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        <div *ngIf="subMenuOpen.expenses && sidebarState !== 'desktop-collapsed'"
          class="mt-1 space-y-1 border-l-2 border-gray-600 ml-6 pl-4 animate-slideDown">
          <a *ngIf="canViewWorkOrders" routerLink="/work-orders"
            class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
            routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400">
            Órdenes de Trabajo
          </a>
          <a *ngIf="canViewExpense" routerLink="/expense-receipts"
            class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
            routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400">
            Comprobantes de Egreso
          </a>
        </div>
      </div>

      <!-- Tesorería -->
      <div class="group" *ngIf="canViewRefunds || canViewExcess || canViewReconciliation || canSendManualReminders">
        <button (click)="toggleSubMenu('treasury')"
          class="flex w-full items-center justify-between rounded-xl px-3 py-2.5 text-left text-sm font-medium text-gray-300 transition-all duration-200 hover:bg-gray-700 hover:text-white group-hover:translate-x-1"
          [ngClass]="{'bg-gray-700 text-white': subMenuOpen.treasury}">
          <div class="flex items-center">
            <svg class="mr-3 h-5 w-5 flex-shrink-0" [ngClass]="{'mr-0': sidebarState === 'desktop-collapsed'}"
              fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z" />
            </svg>
            <span *ngIf="sidebarState !== 'desktop-collapsed'" class="transition-opacity duration-200">Tesorería</span>
          </div>
          <svg *ngIf="sidebarState !== 'desktop-collapsed'" class="h-4 w-4 transition-transform duration-200"
            [ngClass]="{'rotate-180': subMenuOpen.treasury}" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        <div *ngIf="subMenuOpen.treasury && sidebarState !== 'desktop-collapsed'"
          class="mt-1 space-y-1 border-l-2 border-gray-600 ml-6 pl-4 animate-slideDown">
          <a *ngIf="canViewRefunds" routerLink="/refund-vouchers"
            class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
            routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400">
            <span class="flex items-center">
              <svg class="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M7 16l-4-4m0 0l4-4m-4 4h18" />
              </svg>
              Devoluciones
            </span>
          </a>
          <a *ngIf="canViewExcess" routerLink="/dashboard/excess-payments"
            class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
            routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400">
            <span class="flex items-center">
              <svg class="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Excedentes
            </span>
          </a>
          <!-- Conciliaciones Bancarias -->
          <a *ngIf="canViewReconciliation" routerLink="/bank-reconciliation"
            class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
            routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400">
            <span class="flex items-center">
              <svg class="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
              </svg>
              Conciliaciones Bancarias
            </span>
          </a>
          <!-- Períodos Cerrados -->
          <a *ngIf="canViewReconciliation" routerLink="/closed-bank-periods"
            class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
            routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400">
            <span class="flex items-center">
              <svg class="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
              Períodos Cerrados
            </span>
          </a>

          <!-- Notas Débito -->
          <a *ngIf="canViewExpense" routerLink="/debit-notes"
            class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
            routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400">
            <span class="flex items-center">
              <svg class="mr-2 h-4 w-4 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 9v3m0 0v3m0-3h3m-3 0H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Notas Débito
            </span>
          </a>

          <!-- Notas Crédito -->
          <a *ngIf="canViewIncome" routerLink="/credit-notes"
            class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
            routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400">
            <span class="flex items-center">
              <svg class="mr-2 h-4 w-4 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M15 12H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Notas Crédito
            </span>
          </a>

          <!-- Links de Pago -->
          <a *ngIf="canViewPaymentLinks" routerLink="/payment-links"
            class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
            routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400">
            <span class="flex items-center">
              <svg class="mr-2 h-4 w-4 text-blue-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M13.828 10.172a4 4 0 00-5.656 0l-4 4a4 4 0 105.656 5.656l1.102-1.101m-.758-4.899a4 4 0 005.656 0l4-4a4 4 0 00-5.656-5.656l-1.1 1.1" />
              </svg>
              Links de Pago
            </span>
          </a>

          <!-- Recordatorio de pagos manual -->
          <a *ngIf="canSendManualReminders" routerLink="/treasury/manual-reminders"
            class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
            [routerLinkActiveOptions]="{ exact: true }"
            routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400">
            <span class="flex items-center">
              <svg class="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M3 8l9 6 9-6M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
              </svg>
              Recordatorio de pagos manual
            </span>
          </a>

          <!-- Historial de envíos (manual reminders batches) -->
          <a *ngIf="canSendManualReminders" routerLink="/treasury/manual-reminders/batches"
            class="block rounded-lg px-3 py-2 text-sm text-gray-400 transition-colors hover:bg-gray-700 hover:text-white"
            routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400">
            <span class="flex items-center">
              <svg class="mr-2 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
              Historial de envíos
            </span>
          </a>
        </div>
      </div>

      <!-- Reportes — link directo al Centro de Reportes (hub) -->
      <div class="group" *ngIf="canViewReports">
        <a routerLink="/reports"
          class="flex w-full items-center rounded-xl px-3 py-2.5 text-left text-sm font-medium text-gray-300 transition-all duration-200 hover:bg-gray-700 hover:text-white group-hover:translate-x-1"
          routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400"
          [routerLinkActiveOptions]="{ exact: false }">
          <svg class="mr-3 h-5 w-5 flex-shrink-0" [ngClass]="{'mr-0': sidebarState === 'desktop-collapsed'}"
            fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
          </svg>
          <span *ngIf="sidebarState !== 'desktop-collapsed'" class="transition-opacity duration-200">Reportes</span>
        </a>
      </div>

      <!-- Separador -->
      <div *ngIf="sidebarState !== 'desktop-collapsed'" class="my-4 border-t border-gray-600"></div>

      <!-- 🆕 Auditoría de Planes de Pago -->
      <div class="group" *ngIf="canViewPaymentPlanAudit">
        <a routerLink="/dashboard/admin/payment-plan-audit"
          class="flex items-center rounded-xl px-3 py-2.5 text-sm font-medium text-gray-300 transition-all duration-200 hover:bg-gray-700 hover:text-white group-hover:translate-x-1"
          routerLinkActive="bg-gradient-to-r from-rose-600 to-rose-500 text-white shadow-lg">
          <svg class="mr-3 h-5 w-5 flex-shrink-0" [ngClass]="{'mr-0': sidebarState === 'desktop-collapsed'}"
               fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M12 9v2m0 4h.01M5 19h14a2 2 0 001.84-2.75L13.74 4a2 2 0 00-3.48 0l-7.1 12.25A2 2 0 005 19z"/>
          </svg>
          <span *ngIf="sidebarState !== 'desktop-collapsed'"
            class="transition-opacity duration-200">Auditoría Planes</span>
        </a>
      </div>

      <!-- 🆕 Auditoría de Inscripciones -->
      <div class="group" *ngIf="canViewEnrollmentAudit">
        <a routerLink="/dashboard/admin/enrollment-audit"
          class="flex items-center rounded-xl px-3 py-2.5 text-sm font-medium text-gray-300 transition-all duration-200 hover:bg-gray-700 hover:text-white group-hover:translate-x-1"
          routerLinkActive="bg-gradient-to-r from-rose-600 to-rose-500 text-white shadow-lg">
          <svg class="mr-3 h-5 w-5 flex-shrink-0" [ngClass]="{'mr-0': sidebarState === 'desktop-collapsed'}"
               fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/>
          </svg>
          <span *ngIf="sidebarState !== 'desktop-collapsed'"
            class="transition-opacity duration-200">Auditoría Inscripciones</span>
        </a>
      </div>

      <!-- Configuración - Link directo al Hub -->
      <div class="group" *ngIf="canViewConfig">
        <a routerLink="/config"
          class="flex items-center rounded-xl px-3 py-2.5 text-sm font-medium text-gray-300 transition-all duration-200 hover:bg-gray-700 hover:text-white group-hover:translate-x-1"
          routerLinkActive="bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-lg">
          <svg class="mr-3 h-5 w-5 flex-shrink-0" [ngClass]="{'mr-0': sidebarState === 'desktop-collapsed'}" fill="none"
            stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <span *ngIf="sidebarState !== 'desktop-collapsed'"
            class="transition-opacity duration-200">Configuración</span>
        </a>
      </div>
    </nav>
  </div>

  <!-- Footer del sidebar con menú de usuario -->
  <div class="border-t border-gray-700">
    <!-- Modo expandido -->
    <div *ngIf="sidebarState !== 'desktop-collapsed'" class="p-4">
      <!-- Información del usuario -->
      <div class="flex items-center space-x-3 mb-3">
        <div
          class="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-blue-600 text-white text-sm font-semibold shadow-lg">
          {{ userInitials }}
        </div>
        <div class="flex-1 min-w-0">
          <p class="text-sm font-medium text-white truncate">
            {{ currentUser?.fullName || 'Cargando...' }}
          </p>
          <p class="text-xs text-gray-400 truncate">{{ currentUser?.email || '' }}</p>
          <p class="text-xs text-blue-300">{{ userRole }}</p>
        </div>
      </div>

      <!-- Opciones del usuario -->
      <div class="space-y-1">
        <a routerLink="/dashboard/profile"
          class="flex items-center rounded-lg px-3 py-2 text-sm text-gray-300 hover:bg-gray-700 hover:text-white transition-colors"
          routerLinkActive="bg-gradient-to-r from-blue-600/20 to-blue-500/20 text-blue-400">
          <svg class="mr-3 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
          </svg>
          Mi Perfil
        </a>

        <button (click)="logout()"
          class="flex w-full items-center rounded-lg px-3 py-2 text-sm text-red-400 hover:bg-red-900/20 hover:text-red-300 transition-colors">
          <svg class="mr-3 h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          Cerrar Sesión
        </button>
      </div>
    </div>

    <!-- Modo colapsado -->
    <div *ngIf="sidebarState === 'desktop-collapsed'" class="p-2">
      <div class="flex flex-col items-center space-y-2">
        <div class="relative group">
          <div
            class="flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-blue-500 to-blue-600 text-white text-sm font-semibold shadow-lg cursor-pointer">
            {{ userInitials }}
          </div>
          <!-- Tooltip para modo colapsado -->
          <div class="tooltip">
            <div class="bg-gray-800 text-white text-xs rounded py-1 px-2 whitespace-nowrap">
              {{ currentUser?.fullName || 'Usuario' }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</aside>